export default "__VITE_ASSET__y3tKFmuL__ 400w, __VITE_ASSET__CgDWW8ji__ 800w, __VITE_ASSET__CZe0XN9Y__ 1024w";